'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _chats = require('../actions/chats');

var _discussions = require('../actions/discussions');

var _DiscussionCardList = require('./DiscussionCardList');

var _DiscussionCardList2 = _interopRequireDefault(_DiscussionCardList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var mapStateToProps = function mapStateToProps(state, _ref) {
	var chatId = _ref.chatId;
	var status = _ref.status;
	var _ref$reducer = _ref.reducer;
	var reducer = _ref$reducer === undefined ? 'vtChat' : _ref$reducer;
	return {
		discussions: (0, _lodash.filter)((0, _lodash.get)(state, [reducer, 'discussions', chatId], {}), ['status', status]),
		user: (0, _lodash.get)(state, [reducer, 'user'], {})
	};
};

/**
 *
 */
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
	var chatId = _ref2.chatId;
	return {
		onSelect: function onSelect(id) {
			dispatch((0, _chats.setActiveDiscussion)(chatId, id));
		},
		onStatusChange: function onStatusChange(id, user, status) {
			dispatch((0, _discussions.remoteUpdate)(chatId, id, {
				status: status,
				admin: user
			}));
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DiscussionCardList2.default);